import useCountUp from "../hooks/useCountUp";

const CountUp = ({
  end,
  duration = 2000,
  delay = 0,
  suffix = "",
  prefix = "",
  separator = "",
  decimals = 0,
  className = "",
}) => {
  const { count, countRef } = useCountUp(end, duration, 0, delay);

  const formatNumber = (num) => {
    let formattedNum = num;

    // Add decimals if specified
    if (decimals > 0) {
      formattedNum = num.toFixed(decimals);
    }

    // Add thousand separators if specified
    if (separator) {
      formattedNum = formattedNum
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }

    return `${prefix}${formattedNum}${suffix}`;
  };

  return (
    <span ref={countRef} className={className}>
      {formatNumber(count)}
    </span>
  );
};

export default CountUp;
